import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { accountLogin, accountLogout, accountRegister, getSession } from "../lib/api";

const AuthContext = createContext({ signedIn: false, ready: false });

export function AuthProvider({ children }) {
  const [state, setState] = useState({ signedIn: false, email: null, ready: false });

  const refresh = useCallback(async () => {
    try {
      const s = await getSession();
      setState({ signedIn: !!s.signedIn, email: s.email ?? null, ready: true });
    } catch {
      setState({ signedIn: false, email: null, ready: true });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(
    () => ({
      ...state,
      // A sign-in must never cost the customer their cart, so nothing here clears it.
      login: async (email, password) => {
        const r = await accountLogin(email, password);
        await refresh();
        return r;
      },
      // Registration no longer signs anyone in: the answer is deliberately the
      // same whether or not that email already had an account.
      register: async (payload) => accountRegister(payload),
      logout: async () => {
        await accountLogout();
        await refresh();
      },
      refresh,
    }),
    [state, refresh],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
